import React from "react";
// import NewReferrerClinicReport from "./components/NewReferrerClinicReport";
// import NewAptWaitingTimeReport from "./components/NewAptWaitingTimeReport";
import SpecialistFillRateReport from "./components/SpecialistFillRateReport";
import WorkflowReport from "./components/WorkflowReport";
import WorkflowsByAppointmentCreatedReport from "./components/WorkflowsByAppointmentCreatedReport";
import DailyBookedReport from "./components/DailyBookedReport";
import AppointmentReport from "./components/AppointmentReport";

const Report = () => {
  return (
    <div className="columns">
      <div className="column">
        {/*<NewAptWaitingTimeReport />*/}
        {/*<hr />*/}
        {/*<NewReferrerClinicReport />*/}
        {/*<hr />*/}
        <SpecialistFillRateReport />
        <WorkflowReport />
        <WorkflowsByAppointmentCreatedReport />
        <DailyBookedReport />
        <AppointmentReport />
      </div>
    </div>
  );
};

export default Report;
